module.exports = __webpack_public_path__ + "img/backyard-patio.d0bc4da3.webp";